import * as React from 'react';
import { Edit, TextInput, SimpleForm, useTranslate } from 'react-admin';
import { Grid, Typography } from '@mui/material';
import SegmentsFormToolbar from './SegmentsFormToolbar';

const CitiesForm = () => {
    const translate = useTranslate();
    const formDefaults = {
        multiple: true,
        method: 'post',
    };
    return (
        <Edit resource="settings" redirect={false} mutationMode="pessimistic">
            <SimpleForm
                defaultValues={formDefaults}
                toolbar={<SegmentsFormToolbar />}
            >
                <Grid container width={{ xs: '100%', xl: '80%' }} spacing={2}>
                    <Grid
                        item
                        xs={12}
                        md={8}
                        minWidth={{ xs: '100%', xl: '80%' }}
                    >
                        <Typography variant="h4" gutterBottom>
                            {translate('resources.settings.fieldGroups.cities')}
                        </Typography>
                        <TextInput
                            source="Logistics__BaseDomain"
                            label="resources.settings.values.logistics__base_domain"
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Edit>
    );
};

export default CitiesForm;
